import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import "./requeststable.css";
import AssignPropertiesModal from "../../Modals/AssignPropertiesModal/AssignPropertiesModal";
import Delete_Icon from "../../../images/delete_icon.svg";
import Copy_Icon from "../../../images/copy_icon.svg";
import { deleteJSON } from "../../s3/DataRequest/DeleteJSON";
import { GetJSONFileData } from "../../s3/DataRequest/GetJSONFileData";
import { DataRequestContext } from "../../context/DataRequestContext";
import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Table that displays all the JSON files in the Data Requests
 * bucket filtered by the selected Snapshot name (selected in Input Form)
 */

export default function RequestsTable({ data, setData, setNewData }) {
  const [selectedRow, setSelectedRow] = useState(null); // Track the selected row
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null); //Track the selected row index
  const { setFormData } = useContext(DataRequestContext);
  const [phoneError, setPhoneError] = useState(null);  //verify if phone number is correct
  const prefix = process.env.REACT_APP_HOST_PREFIX;
  const company = localStorage.getItem("company");
  const getS3 = useOutletContext().getS3;
  const [S3, setS3] = useState(null);
  const [tooltipCopyToClipboard, setTooltipCopyToClipboard] = useState(false);

  useEffect(() => {
    getS3().then(setS3);
  }, [])

  //Handle the input
  const handleInputChange = (index, field, value) => {
    const updatedData = [...data];
    updatedData[index][field] = value;
    if (updatedData[index].isNew) {
      setNewData([updatedData[index]]);
    } else {
      setData(updatedData);
    }
    if (field === "Phone") {
      validatePhoneNumber(value);
    }
  };

    // Validate phone number using libphonenumber-js
    const validatePhoneNumber = (phoneNumber) => {
      try {
        const phoneNumberObject = parsePhoneNumberFromString(phoneNumber, 'GB'); // Assuming 'US' as default country
        if (phoneNumberObject && phoneNumberObject.isValid()) {
          setPhoneError(null);
        } else {
          setPhoneError("Invalid phone number");
        }
      } catch (error) {
        setPhoneError("Invalid phone number");
      }
    };

  //Get the classname correspondent to the status
  function getStatusClassName(status) {
    switch (status) {
      case "In Progress":
        return "td-in-progress";
      case "Completed":
        return "td-completed";
      case "Merged":
        return "td-merged";
      case "Draft":
        return "td-draft";
      default:
        return "td";
    }
  }

  //Click on the Assigned Properties input to open the Modal
  const handlePropertiesClick = (index) => {
    setSelectedIndex(index);
    setSelectedProperties(
      data[index].AssignedProperties
        ? data[index].AssignedProperties.split(",").map((prop) => prop.trim())
        : []
    );
    setModalOpen(true);
  };

  //Handle Property change in the Modal
  const handlePropertyChange = (newProperties) => {
    const updatedData = [...data];
    updatedData[selectedIndex].AssignedProperties = newProperties.join(", ");
    if (updatedData[selectedIndex].isNew) {
      setNewData([updatedData[selectedIndex]]);
    } else {
      setData(updatedData);
    }
    setModalOpen(false);
  };

  //Delete the row if the user clicks on the delete icon
  const handleDeleteDataRequest = async (index) => {
    const row = data[index];
    if (row.isNew) {
      //For requests there were not sent, delete the row
      const updatedData = [...data];
      updatedData.splice(index, 1);
      setData(updatedData);
    } else {
      try {
        console.log("Deleting file: ", row.requestformlink);
        //For existing requests, delete the JSON in S3
        await deleteJSON(S3, row.requestformlink);
        console.log("Deletion completed for file:", row.requestformlink);

        const updatedData = [...data];
        updatedData.splice(index, 1);
        setData(updatedData);
        console.log("Deleted Row successfully");
      } catch (error) {
        console.log("Row wasn't deleted.", error);
      }
    }
  };

  //Copy the link to clipboard
  const handleContentCopy = (content) => {
    const textArea = document.createElement("textarea");
    textArea.value = `${prefix}/${company}/${content}`;
    textArea.style.position = "fixed";  // Prevent scrolling to bottom of the page in MS Edge.
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    try {
      const successful = document.execCommand('copy');
      if (successful) {
        console.log('Content copied to clipboard.');
        setTooltipCopyToClipboard(true);
        setTimeout(()=> setTooltipCopyToClipboard(false), 3000);
      } else {
        console.error('Failed to copy content to clipboard.');
      }
    } catch (err) {
      console.error('Error copying content to clipboard: ', err);
    }

    document.body.removeChild(textArea);
  };

   // Double click allows to navigate to external form page
   const handleRowDoubleClick = async (link) => {
    try {
      const fileData = await GetJSONFileData(S3, company, link);
      setFormData(fileData);
      navigate(`/${company}/${link}`);
    } catch (error) {
      console.error("Error fetching file data: ", error);
    }
  };

  return (
    <div>
      <table id="requestdata-table">
        <thead>
          <tr>
            <th>Date Time</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Assigned Properties</th>
            <th>Request Form</th>
            <th>Status</th>
            <th>
              <button
                className="requestdata-delete-btn"
                onClick={() => setShowDelete(!showDelete)}
              >
                Delete
              </button>
            </th>
          </tr>
        </thead>
        <tbody className="requestsdata-body">
          {data.map((row, index) => (
            <tr
              key={index}
              className={selectedRow === index ? "clicked" : ""}
                 onDoubleClick={() => handleRowDoubleClick(row.requestformlink)}
            >
              <td>{row.date}</td>
              <td>
                {row.isNew ? (
                  <input
                    type="text"
                    placeholder="Recipient name..."
                    value={row.MemberName}
                    onChange={(e) =>
                      handleInputChange(index, "MemberName", e.target.value)
                    }
                  />
                ) : (
                  row.MemberName
                )}
              </td>
              <td className={
                  row.isNew && phoneError && row.Phone ? "requests-table-phone-error-cell" : ""
                }>
                {row.isNew ? (
                  <>
                  <input
                    type="text"
                    placeholder="Phone number..."
                    value={row.Phone}
                    onChange={(e) =>
                      handleInputChange(index, "Phone", e.target.value)
                    }
                  />
                 
                  </>
                ) : (
                  row.Phone
                )}
              </td>
              <td>
                {row.isNew ? (
                  <input
                    type="text"
                    placeholder="Select properties for user..."
                    value={row.AssignedProperties}
                    onClick={() => handlePropertiesClick(index)}
                    readOnly
                  />
                ) : (
                  row.AssignedProperties
                )}
              </td>
              <td>
                <div className="requestdata-link">
                  {row.isNew ? (
                    <input
                      type="text"
                      placeholder="Auto generated..."
                      value={row.requestformlink}
                      disabled
                      onChange={(e) =>
                        handleInputChange(
                          index,
                          "requestformlink",
                          e.target.value
                        )
                      }
                    />
                  ) : (
                    `${prefix}/${company}/${row.requestformlink}`
                  )}
                  {!row.isNew && (
                    <button
                      className="requestdata-link-btn"
                      onClick={() => handleContentCopy(row.requestformlink)}
                    >
                      <img src={Copy_Icon} alt="copy content icon" />
                    </button>
                  )}
                  {tooltipCopyToClipboard && <span className="tooltip">Link Copied</span>}
                </div>
              </td>
              <td
                className={
                  row.isNew
                    ? getStatusClassName("Draft")
                    : getStatusClassName(row.status)
                }
              >
                {row.isNew ? "Draft" : row.status}
              </td>
              <td>
                {showDelete && (
                  <button
                    className="requestdata-delete-btn"
                    onClick={() => handleDeleteDataRequest(index)}
                  >
                    <img
                      className="requestdata-delete-icon"
                      src={Delete_Icon}
                      alt="bin icon"
                    />
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {modalOpen && (
        <AssignPropertiesModal
          selectedMember={data[selectedIndex].memberName}
          selectedProperties={selectedProperties}
          closeModal={() => setModalOpen(false)}
          onPropertyChange={handlePropertyChange}
          allMembers={data}
        />
      )}
    </div>
  );
}
